import { IFeedBackDto } from "../../models/dto/agendaApi/IFeedBackDto";
import * as ApiWithToken from "../callApiWithToken";

const feedBackService = {
    getFeedBacks: async function (posCode: string, date: string, languageId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_AGENDAS_API + `FeedBack/GetFeedback?posCode=${posCode}&date=${date}&languageId=${languageId}`);
    },
    insertFeedBack: async function (feedBack: IFeedBackDto) {
        return ApiWithToken.postApi(process.env.REACT_APP_AGENDAS_API + `FeedBack/InsertFeedback`, feedBack);
    },
}

export default feedBackService;